<p>
  {{item.cells[fieldDefinition.key].displayText === 'False' ? (item.cells[fieldDefinition.key].value | date :'dd MMMM yyyy') : ''}}
</p>
